import { render } from "./AdminSubscriptionsList.vue?vue&type=template&id=31288e95&scoped=true&ts=true"
import script from "./AdminSubscriptionsList.vue?vue&type=script&lang=ts"
export * from "./AdminSubscriptionsList.vue?vue&type=script&lang=ts"

import "./AdminSubscriptionsList.vue?vue&type=style&index=0&id=31288e95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31288e95"]])

export default __exports__